<template>
    <!-- 证书查询 -->
    <div class="wid-12">
        <div class="" style="" v-show="$route.meta.showFather">
            <div class="box-shadow pad-16">
                <!-- <div class="pad-1 mb-16"> -->
                <div class="flex-1 jus-bet mb-32">
                    <div class="flex-1 jus-bet">
                        <div class="left-icon"></div>
                        <p class="record-1">证书查询</p>
                    </div>
                </div>
                <!-- <div class="flex-1 zhengshu mb-32 jus-bet"> -->
                <el-form ref="ruleForm" :rules="rules" :model="ruleForm" :hide-required-asterisk="true"
                    class="flex-1 zhengshu mb-32 jus-bet" label-width="80px">
                    <el-form-item label="证书编号" prop="no">
                        <el-input v-model="ruleForm.no" placeholder="请输入证书编号"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model="ruleForm.name" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                </el-form>
                <!-- <div class="flex-1">
                        <p>证书编号</p>
                        <el-input v-model="form.name" placeholder="请输入证书编号"></el-input>
                    </div>
                    <div class="flex-1">
                        <p>姓名</p>
                        <el-input v-model="form.no" placeholder="请输入姓名"></el-input>
                    </div> -->
                <!-- </div> -->
                <div class="flex-1 jus-bet">
                    <div></div>
                    <el-button type="primary" @click="search(ruleForm)">查询</el-button>
                    <div></div>
                </div>

            </div>

        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    import {
        getCert
    } from '@/api/personal/api.js';
    export default {
        components: {},
        data() {
            return {
                ruleForm: {
                    no: '',
                    name: ''
                },
                rules: {
                    name: [{
                        required: true,
                        message: '请输入姓名',
                        trigger: 'blur'
                    }],
                    no: [{
                        required: true,
                        message: '请输入证书编号',
                        trigger: 'blur'
                    }],
                }
            }

        },
        methods: {
            record() {
                this.$router.push("/personal/record/index");
            },
            search(ruleForm) {
                this.$refs["ruleForm"].validate((valid) => {
                    if (valid == true) {
                        this.getInit();
                    } else {}
                })
            },
            getInit() {
                getCert(this.ruleForm).then(res => {
                        // console.log('--')
                        if (res.code == 0) {
                            this.$router.push({
                                name:'/certificate/query',
                                params:{
                                    name:this.ruleForm.name,
                                    no:this.ruleForm.no,
                                    img:res.data
                                }
                            });
                            // "/personal/service/certificate/query"
                        }
                    })
                    .catch(error => {

                    });
            },
        }
    }
</script>

<style>

</style>
<style scoped>
    .box-shadow {
        box-shadow: 2px 2px 8px 0px rgba(195, 219, 255, 0.25);
        border-radius: 8px 8px 8px 8px;
    }

    .pad-16 {
        padding: 16px;
    }

    .flex-1 {
        display: flex;
        align-items: center;
    }

    .jus-bet {
        justify-content: space-between;
    }

    .left-icon {
        width: 6px;
        height: 20px;
        background: #3377FF;
        border-radius: 18px;
        margin-right: 10px;
    }

    .record {
        font-size: 14px;
        color: #333333;
        line-height: 21px;
        margin-right: 8px;
    }

    .record-1 {
        font-size: 20px;
        color: #222222;
    }

    .mb-32 {
        margin-bottom: 32px;
    }

    .mb-16 {
        margin-bottom: 16px;
    }

    .el-button--primary {
        background-color: #3377FF;
        color: #ffffff;
        border-radius: 4px;
        font-size: 16px;
        width: 15%;
    }

    .zhengshu {
        /* padding-left: 10px; */
        white-space: nowrap;
        width: 100%;
    }

    /deep/.zhengshu .el-form-item {
        width: 42%;
    }

    .zhengshu .flex-1 {
        width: 40%;
    }

    /deep/.zhengshu .el-form-item__label {
        color: #222222;
        font-size: 14px;
        padding-right: 16px;
    }

    /deep/.zhengshu .el-input__inner {
        /* width: 85%; */
    }

    /deep/.zhengshu .el-input__inner::placeholder {
        color: #999999;
        font-size: 14px;
    }
</style>
